<template>
  <div class="toggle-wrapper">
    <el-menu-item class="submenu-title-noDropdown clear-defaults toggle-button-container">
      <div class="switch-wrapper">
        <div>
          <item :icon="['far', 'hammer']" title="Admin mode" />
        </div>

        <div class="switch-container">
          <ToggleSwitch
            id="admin-switch"
            :checked="getAdminModeState"
            @onChange="onToggleAdminMode"
          />
        </div>
      </div>
    </el-menu-item>
  </div>
</template>

<script>
import Item from './Item';
import ToggleSwitch from '../../../components/ToggleSwitch/toggle-switch';

import {
  getDevBypass,
  enableDevBypass,
  disableDevBypass,
} from '@/utils/devByPass';

export default {
  name: 'GodAdminToggle',
  components: { Item, ToggleSwitch },

  computed: {
    getAdminModeStateText() {
      if (getDevBypass()) {
        return 'Admin mode is On';
      }
      return 'Admin mode is Off';
    },

    getAdminModeState() {
      return getDevBypass();
    },
  },

  methods: {
    onToggleAdminMode() {
      const devBypass = getDevBypass();
      if (devBypass) {
        disableDevBypass();
      } else {
        enableDevBypass();
      }
    },
  },
};
</script>

<style lang="scss">
.clear-defaults {
  padding-left: 0 !important;
  padding-right: 0 !important;
  cursor: none;
  &:hover {
    background-color: transparent !important;
  }
}

.toggle-wrapper {
  margin: 1rem 1rem 2rem 1rem;
  padding-top: 1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.75);
}

.toggle-title-container {
  pointer-events: none;
}

.toggle-button-container {
  height: auto !important;
  line-height: normal !important;
  pointer-events: none;
}

.switch-wrapper {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  align-items: center;
}
</style>
